"use client";

import clsx from "clsx";
import Image from "next/image";
import { useContext } from "react";

import { ReservationsContext } from "../(default)/layout";
import HeaderReservationsBox from "../_components/reservation/header-reservation-box";
import { Link } from "../_components/ui/link";
import { useIsMobile } from "../_hooks/use-responsive-value";

// Notion: https://www.notion.so/sanu/c48fe1187777436685819e9815a520fd?pvs=4
export default function HeaderReservationActions({
  canViewReservationCalendar,
}: {
  canViewReservationCalendar: boolean;
}) {
  const reservations = useContext(ReservationsContext).reservations;

  if (!reservations) return <></>;

  const featured = reservations.find(
    (r) => r.stayStatus === "WillStay" || r.stayStatus === "Staying",
  );
  const actionOfFeatured = featured?.canCheckIn
    ? "checkIn"
    : featured?.canCheckOut
      ? "checkOut"
      : null;

  return (
    <div className="bg-sbeige flex h-full w-full">
      <HeaderReservationsBox
        reservationsData={reservations}
        canViewReservationCalendar={canViewReservationCalendar}
      />
      {featured?.stayStatus === "Staying" && featured?.accessCode && (
        <AccessCode code={featured.accessCode} />
      )}
      {actionOfFeatured && (
        <CheckInCheckOutButton
          action={actionOfFeatured}
          reservationId={featured!.id}
          isEarlyCheckIn={featured!.currentEarlyCheckInFee != null}
        />
      )}
    </div>
  );
}

function CheckInCheckOutButton({
  action,
  reservationId,
  isEarlyCheckIn,
}: {
  action: "checkIn" | "checkOut";
  reservationId: string;
  isEarlyCheckIn: boolean;
}) {
  const isMobile = useIsMobile();
  return (
    <Link
      data-analytics-id="global_header_clicked_checkin_checkout"
      href={
        action === "checkIn"
          ? `/checkin/${reservationId}`
          : `/checkout/${reservationId}`
      }
      className={clsx(
        "bg-sbeige text-skogecha flex min-w-[100px] items-center justify-center px-[8px] text-[9px] font-bold hover:opacity-60",
        { hidden: isMobile && action === "checkOut" },
      )}
    >
      <Image
        src="/i/top_page_triangle_right_icon.svg"
        alt="right"
        width={5}
        height={10}
        priority
      />
      <div className="mr-auto ml-auto text-center leading-tight">
        {action === "checkOut" ? (
          "チェックアウト"
        ) : isEarlyCheckIn ? (
          <>
            アーリー
            <br />
            チェックイン
          </>
        ) : (
          "チェックイン"
        )}
      </div>
    </Link>
  );
}

function AccessCode({ code }: { code: string }) {
  return (
    <div className="bg-slightbeige-116 text-skogecha flex h-full min-w-[100px] flex-col items-center justify-center px-[8px]">
      <div className="text-[8px] leading-none font-bold whitespace-nowrap">
        暗証番号
      </div>
      <div className="font-roboto mt-[4px] text-[18px] leading-none">
        {code}
      </div>
    </div>
  );
}
